module.exports = __webpack_public_path__ + "img/historia9.56b01296.jpg";